import {isLocalhost} from "../../../../../../utils/isLocalhost";

export function VChatLogger(...args) {
  if (isLocalhost()) {
    console.log(...args)
  }
}
